import { makeStyles } from '@mui/styles';
import { display } from '@mui/system';
import { NodeNextResponse } from 'next/dist/server/base-http/node';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  flex: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },

  drawer: {
    flexShrink: 0,
    '& .MuiDrawer-paper': {
      width: '100vw',
      height: '100vh',
      display: 'flex',
      backgroundColor: theme.palette.whitePepper.main,
    },
  },

  mainContainer: {
    marginBottom: '200px',
    padding: '20px 25px',
    width: '100%',
    height: 'max-content',
    display: 'flex',
    flexDirection: 'column',
  },

  iconTiltleClearWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  applyFilterBtnWrapper: {
    display: 'flex',
    justifyContent: 'center',
    padding: '8px',
    position: 'fixed',
    bottom: '0px',
    width: '100%',
    cursor: 'pointer',
    backgroundColor: theme.palette.whitePepper.main,
  },
});
